import { Button, Space, message } from "antd";
import React from "react";
import { UpdateIcon } from "../admin/Icons";
import { usePrefs } from "../utils/Prefs";
import { useTemplate } from "../utils/Template";
import { apiCall } from "../utils/Api";

export default function Save(props) {


    const {templates = []} = props;
    const [prefs, setPrefs] = usePrefs();
    const [template, setTemplate] = useTemplate();

    const live = templates.find(item => item.is_active === true) || {name : ""}
    const { changed = false } = prefs;


    //   apiCall("site_content/setTemplate", {id : 1, name : "Default", content_json : JSON.stringify(defaultTemplate)}, (_status, _result) => {

    //     if(_status){
    //       console.log(_result)
    //     } else {
    //       console.log(_result);
    //     }
    //   })

    // }

    const saveTemplate = () => {

        apiCall("site_content/setTemplate", {
            ...template,
            colours: JSON.stringify(template.colours),
            gradients: JSON.stringify(template.gradients),
            buttons: JSON.stringify(template.buttons),
            texts: JSON.stringify(template.texts.filter(item => (!item.hasOwnProperty("send") || item.send !== false))),
            fonts: JSON.stringify(template.fonts),
            links: JSON.stringify(template.links),

        }, (_status, _result) => {
            if (_status) {
                setTemplate(_result)
            } else {
                message.error(_result.error)
            }
        })

    }




    const save = (e) => {
        if (e) {
            e.stopPropagation();
        }
        message.success("Saved!");
        saveTemplate();
        setPrefs({ ...prefs, "changed": false });
    }

    return (
        <div className="float-flex">
            <Space size={10}>   
            <div style={{"paddingLeft" : "10px"}}><nobr><small>Live: <strong>{live.name}</strong></small></nobr></div>
            <div style={{"padding" : "0px"}}><nobr><small>Editing: <strong>{template.name}</strong></small></nobr></div>
            </Space>
            
            <Button disabled={(!changed)} onClick={() => save()} size="small" type="primary"><small>Save Changes?</small></Button>
        </div>
    )


}